(function (module) {

    module.service('productService', ['$http', productService])

    function productService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.get = () => {
            return $http.get('/api/configuration/product')
                .then(function (response: $TSFixMe) {
                    return response.data;
                });
        };

        service.getAsListOfStrings = () => service.get().then((items: $TSFixMe) => items.map((item: $TSFixMe) => item.name));

        service.import = () => $http.post('/api/configuration/import-products', null);

    }

})(angular.module('topline.modules'));